// extracted by mini-css-extract-plugin
module.exports = {"pre_header":"pre_header___1Ni-g","new":"new___T8b-B","slogan":"slogan___351Uv","sub_slogan":"sub_slogan___CKLsc","feature":"feature___2fXYz","tile":"tile___1-U3S"};